import React, {useEffect, useState} from "react";
import moment, { months } from "moment";
import ReactApexChart from "react-apexcharts";
import Loading from "../../../components/Loading/LoadingEffect";
import {getVoucherGraphData} from "../../../controllers/V1/statisticsReports/statisticsReportsController";
const VoucherBarGraph = () => {
  const [isLoading, setIsLoading]= useState(false);
  const [graphType, setGraphType] = useState('bar');

  const [hour, setHour] = useState([]);
  const [count, setCount] = useState([]);
  const [totalSales, setTotalSales] = useState(0);
  const [filter, setFilter] = useState({
    start_date : `${moment().startOf('month').format('YYYY-MM-DD')}`,
    start_time : `21:30:00`,
    end_date : `${moment().endOf('month').format('YYYY-MM-DD')}`,
    end_time : `21:31:00`,
  })

  const getData = async () => {
    setIsLoading(true);
    try {
      const res = await getVoucherGraphData(filter);
      if(res.status === true){
        if(res.result?.length > 0){  
          let points = 0;
          const hours = [], counts = [], totalSales = [];
          res.result.forEach(item => {
            hours.push(item._id);
            counts.push(item.count);
            const itemPoints = parseFloat(item.total_point) || 0;
            points = itemPoints + points; 
            totalSales.push(points); 
          });
          setHour(hours);
          setCount(counts);
          setTotalSales(points);
        }else{
          setHour(['No order found!']);
          setCount([0]);
          setTotalSales(0);
        } 
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setHour(['No order found!']);
      setCount([0]);
      setTotalSales(0);
    }
  }

  useEffect(()=>{
    getData();
  },[filter])


  const series = [{ name: "Sales", data: count }];

  const options = {
    chart: { height: 350, type: graphType, toolbar: { show: true } },
    colors: ['#C51020'],
    plotOptions: { bar: { borderRadius: 6, columnWidth: '52%' } },
    dataLabels: { enabled: false },
    fill: graphType === 'area' ? {
      type: 'gradient',
      gradient: { shadeIntensity: 1, opacityFrom: 0.55, opacityTo: 0.05, stops: [0, 100] }
    } : { type: 'solid' },
    stroke: { curve: 'smooth', width: graphType === 'area' ? 2 : 0, colors: ['#C51020'] },
    grid: { borderColor: '#f3eded', strokeDashArray: 4 },
    xaxis: { categories: hour, labels: { style: { fontFamily: 'Jost, sans-serif', fontSize: '12px' } } },
    yaxis: { labels: { style: { fontFamily: 'Jost, sans-serif', fontSize: '12px' } } },
    tooltip: { theme: 'light', style: { fontFamily: 'Jost, sans-serif' } },
  };

  const handleChnage = (e) => {
    const {name, value} = e.target;
    setFilter((pre) => ({ ...pre, [name]: value }));
  };

  const ctrl = { fontFamily:'Jost,sans-serif', fontSize:'13px', border:'1.5px solid #e8e0e0', borderRadius:'7px', padding:'6px 10px', background:'#fdf8f8', color:'#2d2d2d', outline:'none' };
  const lbl  = { fontSize:'11px', fontWeight:600, color:'#7B0025', textTransform:'uppercase', letterSpacing:'0.4px', marginBottom:'3px', display:'block' };

  return (
    <>
      <div style={{ background:'#fff', borderRadius:'12px', border:'1px solid #ede8e8', overflow:'hidden', boxShadow:'0 2px 12px rgba(61,0,18,0.07)' }}>
        {/* ── Header ── */}
        <div style={{ borderBottom:'1px solid #f0e8e8', padding:'14px 20px', display:'flex', alignItems:'flex-end', gap:'16px', flexWrap:'wrap', justifyContent:'space-between' }}>
          <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
            <div style={{ width:'4px', height:'28px', borderRadius:'4px', background:'linear-gradient(180deg,#C51020,#7B0025)' }} />
            <div>
              <div style={{ fontSize:'16px', fontWeight:700, color:'#3D0012', fontFamily:'Jost,sans-serif' }}>Voucher Orders</div>
              <div style={{ fontSize:'11px', color:'#999', fontFamily:'Jost,sans-serif' }}>Monthly voucher sales</div>
            </div>
          </div>
          <div style={{ display:'flex', alignItems:'flex-end', gap:'12px', flexWrap:'wrap' }}>
            <div>
              <span style={lbl}>Chart Type</span>
              <select onChange={(e) => setGraphType(e.target.value)} style={ctrl}>
                <option value="bar">Bar Chart</option>
                <option value="area">Area Chart</option>
              </select>
            </div>
            <div>
              <span style={lbl}>From Date</span>
              <input type="date" name="start_date" value={filter?.start_date} onChange={handleChnage} style={ctrl} />
            </div>
            <div>
              <span style={lbl}>From Time</span>
              <input type="time" name="start_time" value={filter?.start_time} onChange={handleChnage} style={ctrl} />
            </div>
            <div style={{ alignSelf:'center', color:'#7B0025', fontWeight:700, fontFamily:'Jost,sans-serif', fontSize:'13px', paddingTop:'14px' }}>→</div>
            <div>
              <span style={lbl}>To Date</span>
              <input type="date" name="end_date" value={filter?.end_date} onChange={handleChnage} style={ctrl} />
            </div>
            <div>
              <span style={lbl}>To Time</span>
              <input type="time" name="end_time" value={filter?.end_time} onChange={handleChnage} style={ctrl} />
            </div>
          </div>
        </div>

        {/* ── Chart ── */}
        <div style={{ padding:'16px 20px 0' }}>
          <ReactApexChart options={options} series={series} type={graphType} height={350} />
        </div>

        {/* ── Footer nav ── */}
        <div style={{ borderTop:'1px solid #f0e8e8', padding:'12px 20px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          <button type="button"
            onClick={() => setFilter((pre) => ({ ...pre, start_date: moment(filter?.start_date).subtract(1, 'months').format('YYYY-MM-DD'), end_date: moment(filter?.end_date).subtract(1, 'months').format('YYYY-MM-DD') }))}
            style={{ fontFamily:'Jost,sans-serif', fontSize:'13px', fontWeight:600, padding:'7px 18px', border:'1.5px solid #e0cccc', borderRadius:'8px', background:'#fff', color:'#3D0012', cursor:'pointer' }}>
            ← Previous Month
          </button>
          <div style={{ textAlign:'center' }}>
            <div style={{ fontSize:'11px', color:'#999', fontFamily:'Jost,sans-serif', textTransform:'uppercase', letterSpacing:'0.5px' }}>Total Sales</div>
            <div style={{ fontSize:'20px', fontWeight:700, color:'#3D0012', fontFamily:'Jost,sans-serif', lineHeight:1.2 }}>{totalSales}</div>
          </div>
          <button type="button"
            onClick={() => setFilter((pre) => ({ ...pre, start_date: moment(filter?.start_date).add(1, 'months').format('YYYY-MM-DD'), end_date: moment(filter?.end_date).add(1, 'months').format('YYYY-MM-DD') }))}
            style={{ fontFamily:'Jost,sans-serif', fontSize:'13px', fontWeight:600, padding:'7px 18px', border:'none', borderRadius:'8px', background:'#3D0012', color:'#fff', cursor:'pointer' }}>
            Next Month →
          </button>
        </div>
      </div>
      <Loading isLoading={isLoading} />
    </>
  );
}

export default VoucherBarGraph;
